import apiClient from './apiClient'

const getEmails = (tenant, outgoing, skip, take) => {
  const params = {
    outgoing,
    skip,
    take
  }
  return apiClient.get(`/${tenant}/Email`, { params })
}

const getEmail = (tenant, emailId) => {
  return apiClient.get(`/${tenant}/Email/${emailId}`)
}

const createEmail = (tenant, email) => {
  const threadId = email.threadId
  return apiClient.post(`/${tenant}/Email/${threadId}/Send`, email)
}

const readEmail = (tenant, emailId) => {
  return apiClient.put(`/${tenant}/Email/${emailId}/read`)
}

const createAttachment = (tenant, emailId, attachment) => {
  return apiClient.post(`/${tenant}/Email/${emailId}/attachment`, attachment,
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      }
    })
}

const getAttachment = (tenant, emailId, attachmentId) => {
  return apiClient.get(`/${tenant}/Email/${emailId}/attachment/${attachmentId}`,
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'multipart/form-data'
      },
      responseType: 'arraybuffer'
    })
}

export default {
  getEmails,
  getEmail,
  getAttachment,
  createEmail,
  readEmail,
  createAttachment
}
